import "@/polyfills";
import React from "react";
import ReactDOM from "react-dom/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import "@/index.css";
import App from "@/App";

// Suppress ONLY the canonical cross-origin "Script error." signature
// emitted by Cloudflare's RUM beacon when the preview tab is opened.
// Real frontend errors (any with a filename or lineno) pass through
// unchanged. Capture-phase listener so we win before CRA's dev overlay.
window.addEventListener("error", (event) => {
  if (
    event.message === "Script error." &&
    !event.filename &&
    (event.lineno === 0 || event.lineno === undefined)
  ) {
    event.stopImmediatePropagation();
    event.preventDefault();
  }
}, true);

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 60_000,
      refetchOnWindowFocus: false,
    },
  },
});

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <App />
    </QueryClientProvider>
  </React.StrictMode>,
);
